<div class="task">
  <span class="task-header-title text-center">Create a New Task</span>
  <div class="task-container">
    <div class="task-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>

